import {Link} from "../../../core/models/Link";
import {HighlightCategory} from "../../../../static/highlightCategory.enum";
import {isLink} from "../../../core/Utils/isLink.typeguard";

export class HighlightAttributes {

  public category: HighlightCategory; // may want to change to enum
  public subject: string;
  public description: string;
  public startDate: Date;
  public expirationDate: Date;
  public link: Link;

  constructor(category: string | number, subject: string, description: string, startDate: string, expirationDate: string, link?: Link | string) {
    this.initCategory(category);
    this.subject = subject;
    this.description = description;
    this.startDate= new Date(startDate);
    this.expirationDate = new Date(expirationDate);
    this.initLink(link);
  }

  public get hasLink(): boolean {
    return !(this.link === null || this.link === undefined);
  }

  private initCategory(category: string | number): void {
    let cat: number;
    if ((typeof category === 'string') && isNaN(+category)) {
      let catStr: string = category as string;
      catStr = catStr.toUpperCase();
      if (HighlightCategory[catStr]) {
        cat = HighlightCategory[catStr];
      }
    } else {
      if (HighlightCategory[category]) {
        const catNum: number = category as number;
        cat = HighlightCategory[HighlightCategory[catNum]];
      }
    }

    if (!cat) {
      cat = HighlightCategory.UNKNOWN;
    }

    this.category = cat;

  }

  private initLink(link?: Link | string): void {
    if (!(link === null || link === undefined)) {
      if (isLink(link)) {
        this.link = link;
      } else {
        this.link = new Link(link);
      }
    }
  }
}
